<template>
  <div style="display: none;">
    <!-- 这个组件不需要渲染任何内容，只负责监听超时事件 -->
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useUserStore } from '@/stores/user'

const router = useRouter()
const userStore = useUserStore()

// 处理用户超时事件
const handleUserTimeout = (event) => {
  const { message } = event.detail
  
  const currentPath = router.currentRoute.value.path
  const isHomePage = currentPath === '/'
  const isLoginPage = currentPath.startsWith('/admin/login') || currentPath.startsWith('/teacher/login') || currentPath.startsWith('/student/login')
  const isDashboardPage = currentPath === '/dashboard'

  // 在首页或任意登录页静默：不提示、不跳转
  if (isHomePage || isLoginPage || isDashboardPage) {
    return
  }

  // 显示超时提示并按模块跳转登录
  ElMessageBox.alert(message, '登录超时', {
    confirmButtonText: '重新登录',
    type: 'warning',
    showClose: false,
    closeOnClickModal: false,
    closeOnPressEscape: false
  }).then(() => {
    const query = { reason: 'timeout', _t: String(Date.now()) }
    if (currentPath.startsWith('/admin')) {
      router.replace({ path: '/admin/login', query })
    } else if (currentPath.startsWith('/teacher')) {
      router.replace({ path: '/teacher/login', query })
    } else if (currentPath.startsWith('/student')) {
      router.replace({ path: '/student/login', query })
    } else {
      router.push('/')
    }
  })
}

onMounted(() => {
  // 监听超时事件
  window.addEventListener('userTimeout', handleUserTimeout)
})

onUnmounted(() => {
  // 清理事件监听器
  window.removeEventListener('userTimeout', handleUserTimeout)
})
</script>
